import dayjs from 'dayjs';

/** Stable empty list for selectors (avoids new [] each render). */
export const EMPTY_CART_ITEMS = Object.freeze([]);

/** Normalize meal / cart line date to YYYY-MM-DD. */
export function mealDateIso(value) {
	if (value == null || value === '') return '';
	return dayjs(value).format('YYYY-MM-DD');
}

/** My cart badge: sum of portions, not line count. */
export function cartQuantityTotal(items) {
	return (items || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
}

export function linesForChild(items, customerId) {
	if (customerId == null || customerId === '') return [];
	const id = Number(customerId);
	return (items || []).filter((item) => Number(item.customerId) === id);
}

export function linesForChildAndDate(items, customerId, dateIso) {
	const dateKey = mealDateIso(dateIso);
	return linesForChild(items, customerId).filter((item) => mealDateIso(item.date) === dateKey);
}

/** Distinct child ids that have unpaid cart lines. */
export function cartOwnerIds(items) {
	const ids = new Set();
	(items || []).forEach((item) => {
		if (item.customerId != null && item.customerId !== '') {
			ids.add(Number(item.customerId));
		}
	});
	return [...ids];
}

/** Distinct meal dates with unpaid lines (family cart). */
export function cartMealDateCount(items) {
	const dates = new Set();
	(items || []).forEach((item) => {
		const d = mealDateIso(item.date);
		if (d) dates.add(d);
	});
	return dates.size;
}

export function childInitials(name) {
	return (name || '')
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((p) => p[0]?.toUpperCase())
		.join('');
}

export function unpaidTotalForLines(lines) {
	return (lines || []).reduce((sum, item) => {
		const addOns = (item.add_ons || []).reduce(
			(a, b) => a + (+b.add_on?.price || +b?.price || 0),
			0
		);
		const unit = ('unit_price' in item ? +item.unit_price : 'price' in item ? +item.price : +item.selling_price) || 0;
		return sum + (unit + addOns) * (Number(item.quantity) || 0);
	}, 0);
}
